import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import { filestackPath } from 'lib/helpers/utility';

import handleDeletionFunction from './handlers/handleDeletion';
import handleEditFunction from './handlers/handleEdit';
import handleShareWithPatientFunction from './handlers/handleShareWithPatient';
import setSelectedAppointmentFunction from './handlers/setSelectedAppointment';

const initConfirmation = { delete: false, share: false };

const useDocumentHandler = ({
  patientId,
  showConfirmation,
  appointmentId,
  setShowConfirmation,
  currentFile,
  setCurrentFile,
  handleCloseModal
}) => {
  const queryClient = useQueryClient();

  const navigate = useNavigate();

  const { myPortalPractice } = useParams();

  const [shareLoading, setShareLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);

  const handleShareWithPatient = async ({ type, id }) =>
    handleShareWithPatientFunction({
      type,
      id,
      setShareLoading,
      showConfirmation,
      patientId,
      navigate,
      queryClient,
      setShowConfirmation,
      initConfirmation
    });

  const handleDeletion = async ({ type, id }) =>
    handleDeletionFunction({
      type,
      id,
      navigate,
      queryClient,
      setDeleteLoading,
      currentFile,
      setShowConfirmation,
      appointmentId,
      setCurrentFile,
      initConfirmation
    });

  const handleEdit = async ({ handle, edit, viewDocument }) =>
    handleEditFunction({
      setEditLoading,
      handle,
      edit,
      navigate,
      queryClient,
      appointmentId,
      viewDocument,
      handleCloseModal,
      myPortalPractice
    });

  const setSelectedAppointment = async (appointment, document) =>
    setSelectedAppointmentFunction({
      appointment,
      document,
      queryClient,
      navigate
    });

  const getUrl = async ({ type, handle, setUrl, setHipaaData, setLoading }) => {
    setLoading((prev) => ({ ...prev, filestack: true }));
    if (
      [
        'image',
        'image/jpg',
        'image/jpeg',
        'image/png',
        'pdf',
        'application/pdf',
        'rtf',
        'application/rtf',
        'eml',
        'application/eml',
        'custom/html',
        'message/rfc822'
      ].includes(type)
    ) {
      setUrl(filestackPath(handle));
    } else if (type === 'hipaa') {
      if (handle?.url) {
        setUrl(filestackPath(handle));
      } else if (handle?.data) {
        if (handle?.data) {
          const hipaaJSON = JSON.parse(handle?.data);
          setHipaaData(decodeURIComponent(hipaaJSON?.htmlData));
        } else {
          setHipaaData(<div>No HIPAA Data</div>);
        }
      }
    }

    setLoading((prev) => ({ ...prev, filestack: false }));
  };

  return {
    shareLoading,
    deleteLoading,
    handleShareWithPatient,
    handleDeletion,
    setSelectedAppointment,
    handleEdit,
    editLoading,
    getUrl
  };
};

export default useDocumentHandler;
